<template>
   <div class="gens-universestd">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_staysafe.jpg" />
             <h1 class="gens-title">{{$t('ContractText.STD_quick_test')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_staysafe.jpg"/>
            <div slot="title">{{$t('ContractText.STD_quick_test')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('stdfastces.stdfastces_one')}}</div>
           <div class="tip_white">{{$t('stdfastces.stdfastces_two')}}</div>
       </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('stdfastces.stdfastces_three')}}</div>
                       <div class="result_line"></div>
                       <div class="result_img_tip">{{$t('stdfastces.stdfastces_four')}}</div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/stdfastces/staysafe-hiv.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_five')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/stdfastces/staysafe-hbv.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_six')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/stdfastces/staysafe-tp.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_seven')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img">
                               <img class="img_science img_science_special" src="../../assets/images/stdfastces/staysafe-hsv2.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_eight')}}</span>
                           </div>
                       </div>
                   </div>
               </div>
        </div>

        <div class="gens_results">
            <div class="gens_results_info">
                <div class="gens_results_info_tip">
                    <div class="results_text">{{$t('stdfastces.stdfastces_nine')}}</div>
                    <div class="results_line"></div>
                </div>
                <div class="gens_results_content">
                    <div class="gens_results_left">
                        <div class="results_left_item">
                            <div class="left_items_img">
                                <img class="left_items_img_img" src="../../assets/images/stdfastces/staysafe-easy.png" alt />   
                            </div>
                            <div class="left_item_tip">
                                <div class="left_item_tip_green">{{$t('stdfastces.stdfastces_ten')}}</div>
                                <div class="left_item_tip_text">{{$t('stdfastces.stdfastces_eleven')}}</div>
                            </div>
                        </div>
                        <div class="results_left_item">
                            <div class="left_items_img">
                                <img class="left_items_img_img" src="../../assets/images/stdfastces/staysafe-privacy.png" alt />   
                            </div>
                            <div class="left_item_tip">
                                <div class="left_item_tip_green">{{$t('stdfastces.stdfastces_twelve')}}</div>
                                <div class="left_item_tip_text"> {{$t('stdfastces.stdfastces_threeteen')}}</div>
                            </div>
                        </div>
                        <div class="results_left_item">
                            <div class="left_items_img">
                                <img class="left_items_img_img" src="../../assets/images/stdfastces/staysafe-easy.png" alt />   
                            </div>
                            <div class="left_item_tip">
                                <div class="left_item_tip_green">{{$t('stdfastces.stdfastces_fourteen')}}</div>
                                <div class="left_item_tip_text">{{$t('stdfastces.stdfastces_fiveteen')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="gens_results_right">
                         <el-carousel indicator-position="outside" arrow="always">
                            <el-carousel-item>
                               <div class="car_img">
                                    <img  src="../../assets/images/stdfastces/ss4in1-1.jpg" alt />  
                                </div> 
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="car_img">
                                    <img  src="../../assets/images/stdfastces/ss4in1-2.jpg" alt />  
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                               <div class="car_img">
                                    <img  src="../../assets/images/stdfastces/ss4in1-3.jpg" alt />  
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
            
        </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('stdfastces.stdfastces_sixteen')}}</div>
                       <div class="result_line"></div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials" src="../../assets/images/stdfastces/instruction250x250-01.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_seventeen')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials" src="../../assets/images/stdfastces/instruction250x250-02.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_eighteen')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special science_item_special_std">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials" src="../../assets/images/stdfastces/instruction250x250-03.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('stdfastces.stdfastces_nineteen')}}</span>
                           </div>
                       </div>
                       
                   </div>
               </div>
        </div>

        <div class="gens_result_std_last">
            <div class="std_last_content">
                <a itemprop="url" href="https://staysafe.com.hk" target="_self" 
                data-hover-background-color="#5ec3b5" data-hover-border-color="#5ec3b5" data-hover-color="#ffffff" class="moreshow" >{{$t('stdfastces.stdfastces_twenty')}}</a>
            </div>
        </div>

   
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    components: {
      banner,
     
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

  @import '../../assets/font/iconfont.css';
.gens-universestd{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color: #5ec3b5;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #15867d;
            text-shadow: 1px 1px 2px #ffffff;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #15867d;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #5ec3b5;
                    font-size: 20px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
             .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                 .science_item{
                    width:25%;
                    text-align: center;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 16px 0px 6px 0px;
                        .abstract_tip{
                           
                            font-size:16px;
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                    }

                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 15px;
                }
                .science_item_special_std{
                    width:33.33% !important;
                    .img_science_specials{
                            width:220px !important;
                    }
                }
             }

             .gens_example{
                 display: flex;
                 justify-content: flex-start;
                 align-items: center;
                 margin-top:35px;
                 .example_item{
                     width:33.33%;
                     margin-right:30px;
                     .example_item_img{
                         display: inline-block;
                        position: relative;
                        margin: 0;
                        width: 100%;
                       
                        .example_item_imgs{

                            max-width: 100%;
                            height: auto;
                            display: block;
                            position: relative;
                            width: 100%;
                            z-index: 10;
                        }
                        
                        .zhezhaoceng{
                            background-color: rgba(241,196,128,0.9);
                            opacity: 0;
                            transition: opacity .4s ease-in-out;
                            z-index: 20;
                            -webkit-transition: opacity .4s ease-in-out;
                            -moz-transition: opacity .4s ease-in-out;
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            left: 0;
                            top: 0;
                            background-color: transparent;
                        }
                        
                        .gens_ex_text{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 30;
                            text-align: center;
                            color:#fff;
                            line-height: 1em;
                            opacity: 1;
                            -webkit-transition: opacity .4s ease-in-out;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                      
                        .gens_ex_text_back{
                            opacity: 0;
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 40;
                            text-align: center;
                            color:#fff;
                            line-height: 1em;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .back_content{
                                .back_text{
                                    margin-bottom: 20px;
                                    color: #ffffff;
                                    font-size: 24px;
                                    font-style: normal;
                                    font-weight: 600;
                                    text-transform: none;
                                    letter-spacing: 1px;
                                }
                                .movie{
                                    color: rgb(255, 255, 255);
                                    border-color: rgb(239, 104, 47);
                                    letter-spacing: 3px;
                                    background-color: rgb(239, 104, 47);
                                    font-size: 14px;
                                    line-height: 36px;
                                    height: 36px;
                                    font-style: normal;
                                    font-weight: 400;
                                    border-width: 2px;
                                    border-radius: 5px;
                                    text-decoration:none;
                                    position: relative;
                                    width: auto;
                                    padding: 0 23px;
                                    transition: color .1s linear , background-color .1s linear , border-color .1s linear;
                                    box-sizing: initial!important;
                                    display:inline-block;
                                    margin: 0;
                                }
                                .movie:hover{
                                    color: rgb(239, 104, 47);
                                    border-color: rgb(255, 255, 255);
                                    letter-spacing: 3px;
                                    background-color: rgb(255, 255, 255);
                                }
                            }
                        }
                     }
                     .example_item_img:hover{
                         .zhezhaoceng{
                             opacity: 1;
                             background-color: rgba(241,196,128,0.9);
                         }
                         .gens_ex_text{
                             opacity: 0;
                         }
                         .gens_ex_text_back{
                             opacity: 1;
                         }
                     }
                 }
             }

             .gens_result_example{
                   display:flex;
                  justify-content: left;
                  flex-direction: row;
                  .gens_result_example_item{
                      margin-right:30px;
                      width:380px;
                      background: rgba(249,218,179,.2);
                      padding: 40px 30px;
                      box-sizing: border-box;
                      text-align: center;
                      display:flex;
                      flex-direction: column;
                      justify-content: center;
                      .gens_result_example_item_img{
                              border-radius: 50%;
                              margin-bottom: 33px;
                              text-align: center;
                              vertical-align: middle;
                              margin: 0 0 50px;
                              display: inline-block;
                              position: relative;
                              overflow: hidden;
                          .gens_result_example_item_imgs{
                              width: 150px;
                              max-width: 100%;
                              height: auto;
                          }
                      }
                      .gens_result_example_tip{
                            color: #ef682f;
                            padding-bottom: 20px;
                            font-size: 24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.304347826086957em;
 
                      }
                      .gens_result_example_content{
                              text-align: left;
                              color: #3a3a3a;
                              font-size:16px;
                              font-weight: 400;
                              line-height: 24px;
                              font-style: normal;
                      }
                      .gens_result_example_bottom{
                          text-align: center;
                          color: #ef682f;
                          margin-top: 21px;
                          font-size: 13px;
                          font-weight: 500;
                          line-height: 24px;
                          font-style: normal;
                      }
                  }
             }
             

         }
         
    }


    .gens_results{
         background-color: rgba(192,227,221,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_results_info{
             width:1200px;
             margin:auto;
             .gens_results_info_tip{
                 .results_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .results_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 
            }
            .gens_results_content{
                display: flex;
                justify-content: flex-start;
                flex-direction: row;

                .gens_results_left{
                    width: 50%;
                    display:flex;
                    justify-content: flex-start;
                    flex-direction: column;
                    .results_left_item{
                        margin-bottom:30px;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        .left_items_img{
                            display: inline-block;
                            position: relative;
                            z-index: 2;
                            .left_items_img_img{
                                max-width: 100%;
                                height: auto;
                                width: 78px;
                            }
                        }
                        .left_item_tip{
                            padding: 0 0 18px 35px;
                            .left_item_tip_green{
                                color: #15867d;
                                font-size: 28px;
                                font-style: normal;
                                font-weight: 700;
                                text-transform: none;
                                line-height: 1.384615384615385em;
                                letter-spacing: 1px;
                            }
                            .left_item_tip_text{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                display: block;
                            }
                        }
                        
                    }
                }
                .gens_results_right{
                    width:50%;
                    height: auto;
                    margin: 0 0 20px;
                    .car_img{
                        text-align: center;
                        position: relative;
                        width: 100%;
                        margin-right: -100%;
                        position: relative;
                        opacity: 1;
                        display: block;
                        z-index: 2;
                        img{
                           max-width: 100%;
                           height: 300px; 
                        }
                    }
                }
            }
            
        }
    }

     
     .gens_result_std_last{
         margin-top:30px;
        background-image: url(../../assets/images/stdfastces/staysafe-order-now.jpg);
        text-align: left;
        position: relative;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        .std_last_content{
            padding-top: 255px;
            padding-bottom: 260px;
            text-align: center;
            height: 40px;
            .moreshow{
                box-sizing: border-box;
                padding:10px 25px;
                
                color: rgb(255, 255, 255);
                border-color: rgb(21, 134, 125);
                letter-spacing: 3px;
                background-color: rgb(21, 134, 125);
                font-size: 14px;
                line-height: 36px;
                height: 36px;
                font-style: normal;
                font-weight: 400;
                border-radius: 5px;
                -moz-border-radius: 5px;
                -webkit-border-radius: 5px;
                letter-spacing: 3px;
                text-transform: none;
                border-width: 2px;
                cursor: pointer;
                text-decoration: none;
                white-space: nowrap;
            }
            .moreshow:hover{
                background-color:rgb(94,195,181);
            }
        }
     }


    
           

}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/stdfastces.vue